// extracted by mini-css-extract-plugin
module.exports = {"typeSelect":"typeSelect__HpM7d","typeSelectDropdownClassName":"typeSelectDropdownClassName__FsCJS"};